import { licensingConstants, userConstants } from '../../constants/index';
import {licensingService, userService} from '../../services/index';
import {alertActions} from '../index';
import { history } from '../../../helpers/history';
import { SECURITY_ROLES } from '../../../constants/SECURITY_ROLES';
import { maestroenv } from '../../../helpers/maestroenv';

export const licensingActions = {
  generateRandomPhrase,
  validateLicense,
  uploadLicenseFiles
};

function validateLicense(authenticatedUser, checkLicense, routeToShow) {
  return dispatch => {
    if (!checkLicense){
      history.push(routeToShow);
    } else {
      if (authenticatedUser.licenseResult === 1) {
        history.push(routeToShow)
      } else if (authenticatedUser.licenseResult === 0) {
        dispatch(alertActions.error(authenticatedUser.licenseMessage))
        history.push({
          pathname: '/license/error',
          state: {
            errorCode: authenticatedUser.licenseResult,
            errorMessage: authenticatedUser.licenseMessage
          }
        });
      } else if (authenticatedUser.licenseResult < 0) {
        // if (authenticatedUser.role.toLowerCase().includes('admin') && (authenticatedUser.licenseResult === -1)) {
        if ((authenticatedUser.availableRoles.includes(SECURITY_ROLES.COMPANY_ADMIN)) && (authenticatedUser.licenseResult === -1)) {
          dispatch(generateRandomPhrase()).then (
            licenseResult => {
              history.push({
                pathname: '/license/request',
                state: {
                  requestType: 'New',
                  randomPhrase: licenseResult.random_phrase,
                  request_filename: licenseResult.new_filename,
                  errorMessage: authenticatedUser.licenseMessage
                }
              })
            }
          )
        } else {
          dispatch(alertActions.error(authenticatedUser.licenseMessage))
          history.push({
            pathname: '/license/error',
            state: {
              errorCode: authenticatedUser.licenseResult,
              errorMessage: authenticatedUser.licenseMessage
            }
          });
        }
      }
    }

  }

  function request(phrase) {
    return {type: licensingConstants.VALIDATE_LICENSE_REQUEST, phrase}
  }

  function success(licensing) {
    return {type: licensingConstants.VALIDATE_LICENSE_SUCCESS, licensing}
  }

  function failure(error) {
    return {type: licensingConstants.VALIDATE_LICENSE_FAILURE, error}
  }
}

function uploadLicenseFiles(uploadFields) {
  return dispatch => {
    dispatch(request(uploadFields));
    return licensingService.uploadLicense(uploadFields)
      .then(
        licensing => {
          dispatch(successUpload(licensing.data));
          dispatch(success(licensing.data.userData.token));
          localStorage.setItem('token', JSON.stringify(licensing.data.userData.token))
          return licensing.data
        },
        error => {
          localStorage.removeItem('token');
          dispatch(failure(error.toString()));
          dispatch(alertActions.error(error.toString()));
          userService.logout();
          return error;
        }
      );
  };

  function request(uploadFields) {
    return {type: licensingConstants.UPLOAD_LICENSE_REQUEST, uploadFields}
  }

  function successUpload(licensing) {
    return {type: licensingConstants.UPLOAD_LICENSE_SUCCESS, licensing}
  }

  function success(user) {
    return {type: userConstants.UPDATE_TOKEN_ON_LICENSE_SUCCESS, user}
  }

  function failure(error) {
    return {type: licensingConstants.UPLOAD_LICENSE_FAILURE, error}
  }
}

function generateRandomPhrase() {
  return dispatch => {
    dispatch(request());
    return licensingService.generateRandomPhrase()
      .then(
        licensing => {
          dispatch(success(licensing.data))
          return licensing.data
        },
        error => {
          dispatch(failure(error.toString()));
          dispatch(alertActions.error(error.toString()));
          userService.logout();
          return error;
        }
      );
  };

  function request() {
    return {type: licensingConstants.GENERATE_PHRASE_REQUEST}
  }

  function success(licensing) {
    return {type: licensingConstants.GENERATE_PHRASE_SUCCESS, licensing}
  }

  function failure(error) {
    return {type: licensingConstants.GENERATE_PHRASE_FAILURE, error}
  }
}

